import { render, staticRenderFns } from "./SwitchPosVendaField.vue?vue&type=template&id=c69a7fdc&scoped=true&"
import script from "./SwitchPosVendaField.vue?vue&type=script&lang=js&"
export * from "./SwitchPosVendaField.vue?vue&type=script&lang=js&"
import style0 from "./SwitchPosVendaField.vue?vue&type=style&index=0&id=c69a7fdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c69a7fdc",
  null
  
)

export default component.exports